var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.sharedSubscriptions
        ? _c("v-skeleton-loader", {
            staticClass: "mb-6",
            attrs: {
              type: "list-item-avatar-three-line, list-item-avatar-three-line, list-item-avatar-three-line",
              boilerplate: "",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-expansion-panels",
        {
          attrs: { flat: "" },
          on: {
            change: function ($event) {
              return _vm.$emit("change")
            },
          },
          model: {
            value: _vm.panel,
            callback: function ($$v) {
              _vm.panel = $$v
            },
            expression: "panel",
          },
        },
        _vm._l(
          _vm.getSharedSubscriptions.filter((e) => !e.void),
          function (item, index) {
            return _c(
              "v-expansion-panel",
              {
                key: item.id,
                class: ["soli-round mb-2 mt-0", `panel-${index}`],
                attrs: { disabled: _vm.disablePanel(item) },
              },
              [
                _c(
                  "v-expansion-panel-header",
                  {
                    class: ["soli-round mb-2 py-0 soli-grey"],
                    attrs: {
                      "expand-icon": "keyboard_arrow_down",
                      focusable: "",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$log(item.id)
                      },
                    },
                  },
                  [
                    _c(
                      "v-row",
                      { staticClass: "max-w-full", class: ["align-center"] },
                      [
                        false
                          ? _c(
                              "v-col",
                              { staticClass: "col-3 flex justify-center" },
                              [
                                _c("SoliStatusAvatar", {
                                  attrs: {
                                    purchaseOption: item,
                                    event: item.lesson,
                                    noShadow: "",
                                    size: "56",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          {
                            class: [
                              "pl-0",
                              _vm.paidForBy(item)
                                ? "v-expansion-panel--disabled"
                                : null,
                            ],
                          },
                          [
                            _c(
                              "v-list",
                              { staticClass: "mx-2" },
                              [
                                _c("div", { staticClass: "caption" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        item.category == "memberships"
                                          ? _vm.globalMomentFullISO(
                                              new Date(item.starts_at)
                                            ) > _vm.globalMomentFullISO()
                                            ? `Starts on ${_vm.globalMomentDateDots(
                                                item.starts_at
                                              )}`
                                            : !item.ends_at
                                            ? `Auto-renews on ${_vm.globalMomentDateDots(
                                                item.cycle
                                              )}`
                                            : `Ends on ${_vm.globalMomentDateDots(
                                                // globalMomentUTC(
                                                item.ends_at
                                                //)
                                              )}`
                                          : item.category == "offers"
                                          ? null
                                          : `${
                                              item.passes > 0
                                                ? `${item.passes} Visit(s) Remaining`
                                                : "No remaining visits"
                                            }`
                                      ) +
                                      "\n                            "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    class: _vm.$vuetify.breakpoint.xsOnly
                                      ? "body-2"
                                      : "body-1",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(item.name) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                !_vm.paidForBy(item)
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "caption flex flex-wrap items-center justify-start gap-x-2",
                                      },
                                      [
                                        _vm.getRelated(item.recipient.id)
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex gap-1 items-center shrink",
                                              },
                                              [
                                                _c(
                                                  "v-avatar",
                                                  { attrs: { size: "20" } },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: _vm.getRelated(
                                                          item.recipient.id
                                                        ).profile_photo_path
                                                          ? `/api/image-service/20x20/${
                                                              _vm.getRelated(
                                                                item.recipient
                                                                  .id
                                                              )
                                                                .profile_photo_path
                                                            }`
                                                          : _vm.getRelated(
                                                              item.recipient.id
                                                            ).profile_photo_url,
                                                      },
                                                    }),
                                                  ]
                                                ),
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(
                                                      _vm.getRelated(
                                                        item.recipient.id
                                                      ).first_name
                                                    ) +
                                                    "\n                                "
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.getRelated(item.recipient.id)
                                          ? _c("v-divider", {
                                              attrs: { vertical: "" },
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex items-center justify-start shrink",
                                          },
                                          [
                                            item.category == "memberships" &&
                                            item.contract_url !== "admin" &&
                                            !item.contract_url
                                              ? _c(
                                                  "v-icon",
                                                  {
                                                    class: [
                                                      "pr-1",
                                                      item.contract_url
                                                        ? "primary--text"
                                                        : "error--text",
                                                    ],
                                                    attrs: { small: "" },
                                                  },
                                                  [_vm._v("description")]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            item.category == "memberships" &&
                                            item.contract_url
                                              ? _c(
                                                  "v-icon",
                                                  {
                                                    staticClass:
                                                      "pr-1 dark--text",
                                                    attrs: { small: "" },
                                                  },
                                                  [_vm._v("event_repeat")]
                                                )
                                              : _vm._e(),
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  `${_vm.formatUnitAmount(
                                                    item.price.unit_amount
                                                  )}`
                                                ) +
                                                "\n                                "
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        item.price.coupon_id
                                          ? _c(
                                              "div",
                                              { staticClass: "contents" },
                                              [
                                                _c("v-divider", {
                                                  attrs: { vertical: "" },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "caption flex shrink",
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticClass:
                                                          "pr-1 dark--text",
                                                        attrs: { small: "" },
                                                      },
                                                      [_vm._v("local_offer")]
                                                    ),
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          item.price.expires_at
                                                            ? `Until ${_vm.globalMomentDateDots(
                                                                item.price
                                                                  .expires_at
                                                              )}`
                                                            : "Forever"
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("v-divider", {
                                          attrs: { vertical: "" },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "caption flex" },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                staticClass: "pr-1 dark--text",
                                                attrs: { small: "" },
                                              },
                                              [_vm._v("storefront")]
                                            ),
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  `${item.location.name}`
                                                ) +
                                                "\n                                "
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                item.tags?.length
                                  ? _c(
                                      "v-list-item-subtitle",
                                      { staticClass: "py-1" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex gap-1 align-center flex-wrap",
                                          },
                                          _vm._l(item.tags, function (tag) {
                                            return _c(
                                              "v-chip",
                                              {
                                                key: tag.id,
                                                staticClass:
                                                  "white--text font-weight-bold text-capitalize",
                                                attrs: {
                                                  "x-small": "",
                                                  color: tag.color,
                                                },
                                              },
                                              [_vm._v(_vm._s(tag.name))]
                                            )
                                          }),
                                          1
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                item.pendingExit
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "caption flex error--text",
                                      },
                                      [
                                        _vm._v(
                                          "\n                                Pending Exit Form\n                            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.viewAtOptionLocation(item) &&
                                _vm.panel === index
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "error--text flex caption",
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              `Only editiable in ${item.location.name}`
                                            ) +
                                            "\n                            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.paidForBy(item)
                                  ? _c("div", { staticClass: "caption" }, [
                                      _vm.relationships.length
                                        ? _c("div", [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  `Paid for by ${
                                                    _vm.relationships.find(
                                                      (e) =>
                                                        e.id == item.user_id
                                                    ).name
                                                  }`
                                                ) +
                                                "\n                                "
                                            ),
                                          ])
                                        : _vm._e(),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.$page.props.staffView &&
                                item.lesson &&
                                _vm.panel !== false &&
                                _vm.panel !== undefined
                                  ? _c("div", [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "soli-grey font-weight-bold py-1",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    Lesson:\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "caption soli-grey" },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                `${_vm.globalMomentWeekDay(
                                                  item.lesson.start
                                                )} at ${_vm.globalMomentTime(
                                                  item.lesson.start
                                                )}`
                                              ) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "caption soli-grey" },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                `${
                                                  item.lesson.instrument.name ??
                                                  ""
                                                } w/ ${
                                                  item.lesson.teacher.name
                                                }`
                                              ) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-expansion-panel-content",
                  [
                    _c(
                      "v-row",
                      { staticClass: "justify-around align-center py-5" },
                      [
                        _vm.$page.props.staffView &&
                        _vm.can("Manage memberships") &&
                        (!item.ends_at || item.gracePeriod)
                          ? _c(
                              "v-btn",
                              {
                                attrs: {
                                  icon: "",
                                  small: "",
                                  color: "dark",
                                  loading: _vm.loading,
                                  disabled:
                                    !_vm.viewAtOptionLocation(item) ||
                                    (item.passes == 0 &&
                                      item.category == "passes" &&
                                      !!item.paid),
                                },
                                on: {
                                  click: function ($event) {
                                    item.ends_at
                                      ? (_vm.confirmResumeMembership = item.id)
                                      : [
                                          (_vm.selectedMembership = item),
                                          (_vm.editSubscription = true),
                                        ]
                                  },
                                },
                              },
                              [
                                _c("v-icon", [
                                  _vm._v(
                                    _vm._s(
                                      item.ends_at ? "restart_alt" : "edit"
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "small",
                                  {
                                    staticClass: "mt-1 panel-text",
                                    staticStyle: { "white-space": "normal" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        item.ends_at
                                          ? "Resume Membership"
                                          : "Edit"
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$page.props.staffView
                          ? _c(
                              "v-btn",
                              {
                                attrs: {
                                  icon: "",
                                  small: "",
                                  color: "dark",
                                  disabled:
                                    !_vm.relationships.length ||
                                    item.passes == 0 ||
                                    !!item.lesson ||
                                    !_vm.viewAtOptionLocation(item),
                                },
                                on: {
                                  click: function ($event) {
                                    ;[
                                      (_vm.transferOption = item),
                                      (_vm.transferForm.user =
                                        _vm.relationshipsAndMe.find(
                                          (e) =>
                                            e.id == _vm.transferOption.user_id
                                        )),
                                      (_vm.transferForm.recipient =
                                        _vm.relationshipsAndMe.find(
                                          (e) =>
                                            e.id ==
                                            _vm.transferOption.recipient.id
                                        )),
                                      (_vm.transferForm.passes =
                                        _vm.transferOption.passes),
                                    ]
                                  },
                                },
                              },
                              [
                                _c("v-icon", [_vm._v("share")]),
                                _vm._v(" "),
                                _c(
                                  "small",
                                  {
                                    staticClass: "mt-1 panel-text",
                                    staticStyle: { "white-space": "normal" },
                                  },
                                  [_vm._v("Transfer")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$page.props.staffView && item.category == "offers"
                          ? _c(
                              "v-btn",
                              {
                                attrs: {
                                  icon: "",
                                  small: "",
                                  color: "dark",
                                  disabled: !_vm.viewAtOptionLocation(item),
                                },
                                on: {
                                  click: function ($event) {
                                    ;[
                                      (_vm.creditForm.show = true),
                                      (_vm.creditForm.purchaseOptionId =
                                        item.id),
                                    ]
                                  },
                                },
                              },
                              [
                                _c("v-icon", [_vm._v("redeem")]),
                                _vm._v(" "),
                                _c(
                                  "small",
                                  {
                                    staticClass: "mt-1 panel-text",
                                    staticStyle: { "white-space": "normal" },
                                  },
                                  [_vm._v("Redeem")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.canVoid(item)
                          ? _c(
                              "v-btn",
                              {
                                attrs: {
                                  icon: "",
                                  small: "",
                                  color: "dark",
                                  disabled: !_vm.viewAtOptionLocation(item),
                                },
                                on: {
                                  click: function ($event) {
                                    ;[(_vm.confirmRemoveOption = item)]
                                  },
                                },
                              },
                              [
                                _c("v-icon", [_vm._v("remove_circle_outline")]),
                                _vm._v(" "),
                                _c(
                                  "small",
                                  {
                                    staticClass: "mt-1 panel-text",
                                    staticStyle: { "white-space": "normal" },
                                  },
                                  [_vm._v("Remove")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !item.paid && !_vm.$page.props.staffView
                          ? _c(
                              "v-btn",
                              {
                                attrs: {
                                  icon: "",
                                  small: "",
                                  color: "soli-status-green",
                                  href: _vm.route("prepay"),
                                },
                              },
                              [
                                _c("v-icon", [_vm._v("attach_money")]),
                                _vm._v(" "),
                                _c(
                                  "small",
                                  {
                                    staticClass: "mt-1 panel-text soli-grey",
                                    staticStyle: { "white-space": "normal" },
                                  },
                                  [_vm._v("Pay Now")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.contract_url && item.contract_url !== "admin"
                          ? _c(
                              "a",
                              {
                                attrs: {
                                  target: "_blank",
                                  href: _vm.route(
                                    "contract.view",
                                    item.hash_id
                                  ),
                                },
                              },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      icon: "",
                                      small: "",
                                      color: "dark",
                                    },
                                  },
                                  [
                                    _c("v-icon", [_vm._v("description")]),
                                    _vm._v(" "),
                                    _c(
                                      "small",
                                      {
                                        staticClass: "mt-1 panel-text",
                                        staticStyle: {
                                          "white-space": "normal",
                                        },
                                      },
                                      [_vm._v("View Contract")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.unsignedContract
                          ? _c(
                              "v-btn",
                              {
                                attrs: { icon: "", small: "", color: "dark" },
                                on: {
                                  click: function ($event) {
                                    _vm.loadContract = item
                                  },
                                },
                              },
                              [
                                _c("v-icon", [_vm._v("description")]),
                                _vm._v(" "),
                                _c(
                                  "small",
                                  {
                                    staticClass: "mt-1 panel-text",
                                    staticStyle: { "white-space": "normal" },
                                  },
                                  [_vm._v("Sign Contract")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.category == "memberships" &&
                        !_vm.$page.props.staffView
                          ? _c(
                              "v-btn",
                              {
                                attrs: { icon: "", small: "", color: "dark" },
                                on: {
                                  click: function ($event) {
                                    _vm.contactStudio = item
                                  },
                                },
                              },
                              [
                                _c("v-icon", [_vm._v("help")]),
                                _vm._v(" "),
                                _c(
                                  "small",
                                  {
                                    staticClass: "mt-1 panel-text",
                                    staticStyle: { "white-space": "normal" },
                                  },
                                  [_vm._v("Ask a Question")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }
        ),
        1
      ),
      _vm._v(" "),
      _vm.confirmResumeMembership
        ? _c("SoliChoice", {
            attrs: {
              title: "Resume Membership",
              subtitle:
                "This withdrawal will be reversed and billing will resume. You'll still need to schedule new lessons if they were cancelled.",
              button1: "Confirm",
              button2: "Nevermind",
            },
            on: {
              option1: function ($event) {
                return _vm.resumeMembership(_vm.confirmResumeMembership)
              },
              option2: function ($event) {
                _vm.closeModal(() => [
                  (_vm.confirmResumeMembership = false),
                  (_vm.editSubscription = null),
                ])
              },
              reset: function ($event) {
                _vm.closeModal(() => [
                  (_vm.confirmResumeMembership = false),
                  (_vm.editSubscription = null),
                ])
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.editSubscription
        ? _c("ManageSubscription", {
            attrs: { purchaseOption: _vm.selectedMembership, user: _vm.user },
            on: {
              success: function ($event) {
                _vm.closeModal(() => _vm.$emit("success"))
              },
              reset: function ($event) {
                _vm.closeModal(() => [
                  (_vm.editSubscription = null),
                  (_vm.selectedMembership = null),
                ])
              },
              changePrice: function ($event) {
                ;[(_vm.showChangePrice = true), (_vm.editSubscription = null)]
              },
              editDetails: function ($event) {
                ;[
                  (_vm.showEditMembershipDetails = true),
                  (_vm.editSubscription = null),
                ]
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showChangePrice
        ? _c("ChangeMembershipPrice", {
            attrs: { purchaseOption: _vm.selectedMembership, user: _vm.user },
            on: {
              success: function ($event) {
                _vm.closeModal(() => _vm.$emit("success"))
              },
              reset: function ($event) {
                _vm.closeModal(() => [
                  (_vm.showChangePrice = null),
                  (_vm.selectedMembership = null),
                ])
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showEditMembershipDetails
        ? _c("EditMembershipDetails", {
            attrs: { purchaseOption: _vm.selectedMembership },
            on: {
              success: function ($event) {
                _vm.closeModal(() => _vm.$emit("success"))
              },
              reset: function ($event) {
                _vm.closeModal(() => [
                  (_vm.showEditMembershipDetails = null),
                  (_vm.selectedMembership = null),
                ])
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.transferOption
        ? _c("SoliForm", {
            ref: "transferForm",
            attrs: { title: `Transfer ${_vm.transferOption.name}` },
            on: {
              submit: _vm.handleTransfer,
              reset: function ($event) {
                _vm.transferOption = null
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "flex flex-col gap-4" },
                        [
                          _c("v-autocomplete", {
                            staticClass: "soli-blue-text",
                            attrs: {
                              items: _vm.relationshipsAndMe,
                              "no-data-text": "No relationships found",
                              "item-text": "name",
                              "item-value": "id",
                              label: "Relationships",
                              outlined: "",
                              "return-object": "",
                              dense: "",
                              "prepend-inner-icon": "people",
                              "error-messages": _vm.errors.recipient,
                              "hide-details": "auto",
                              rules: [(v) => !!v || "Item is required"],
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "item",
                                  fn: function (data) {
                                    return [
                                      _c("v-list-item-avatar", [
                                        _c("img", {
                                          attrs: {
                                            src: data.item.profile_photo_url,
                                          },
                                        }),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c("v-list-item-title", {
                                            domProps: {
                                              innerHTML: _vm._s(data.item.name),
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("v-list-item-subtitle", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                data.item.email
                                              ),
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2195692975
                            ),
                            model: {
                              value: _vm.transferForm.recipient,
                              callback: function ($$v) {
                                _vm.$set(_vm.transferForm, "recipient", $$v)
                              },
                              expression: "transferForm.recipient",
                            },
                          }),
                          _vm._v(" "),
                          _c("SoliText", {
                            staticClass: "soli-round",
                            attrs: {
                              min: 1,
                              max: Number(_vm.transferOption.passes),
                              label: "Passes to transfer",
                              outlined: "",
                              dense: "",
                              number: "",
                              "hide-details": "",
                              icon: "sync_alt",
                            },
                            model: {
                              value: _vm.transferForm.passes,
                              callback: function ($$v) {
                                _vm.$set(_vm.transferForm, "passes", $$v)
                              },
                              expression: "transferForm.passes",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2758875682
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.creditForm.show
        ? _c("SoliForm", {
            ref: "creditForm",
            attrs: {
              title: "Redeem Offer",
              textSubtitle: "Redeem this offer and credit user account?",
              text: "Save",
              icon: "save",
            },
            on: {
              submit: function ($event) {
                return _vm.handleRedeemOffer()
              },
              reset: function ($event) {
                ;[(_vm.creditForm.show = false), (_vm.creditForm.amount = null)]
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c("v-currency-field", {
                        staticClass: "soli-round",
                        attrs: {
                          label: "Amount to credit account",
                          rules: _vm.creditForm.rules,
                          outlined: "",
                          dense: "",
                          "error-message": "errors.amount",
                          "hide-details": "auto",
                        },
                        model: {
                          value: _vm.creditForm.amount,
                          callback: function ($$v) {
                            _vm.$set(_vm.creditForm, "amount", $$v)
                          },
                          expression: "creditForm.amount",
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              282913764
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loadContract
        ? _c("Contracts", {
            attrs: {
              contracts: _vm.loadContract.unsignedContract,
              client: _vm.user,
              purchaseOption: _vm.loadContract,
            },
            on: {
              success: function ($event) {
                return _vm.$emit("success")
              },
              reset: function ($event) {
                _vm.closeModal(() => (_vm.loadContract = false))
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.confirmRemoveOption
        ? _c("SoliChoice", {
            ref: "removeOptionForm",
            attrs: {
              title: "Are you sure?",
              subtitle: `This purchase option will be removed from ${
                _vm.user.first_name
              }'s account. ${
                _vm.confirmRemoveOption.paid
                  ? "This option is paid and might still need to be refunded."
                  : ""
              }`,
              button1: "Confirm",
              button2: "Nevermind",
              loading1: "",
            },
            on: {
              reset: function ($event) {
                _vm.closeModal(() => (_vm.confirmRemoveOption = null))
              },
              option1: function ($event) {
                return _vm.handleRemoveOption(_vm.confirmRemoveOption)
              },
              option2: function ($event) {
                _vm.closeModal(() => (_vm.confirmRemoveOption = null))
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showEoMWarning
        ? _c("SoliChoice", {
            attrs: {
              button1: "Continue",
              button2: "Nevermind",
              title: "Are you sure?",
              subtitle:
                "This membership will be cancelled without 30 days notice. This is not recommended.",
              warning: "",
            },
            on: {
              reset: function ($event) {
                return _vm.cancelEditSubscription($event)
              },
              option2: function ($event) {
                return _vm.cancelEditSubscription(true)
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.contactStudio
        ? _c("SoliResponsiveDialog", {
            ref: "locationContact",
            attrs: { title: "Contact Us!" },
            on: {
              reset: function ($event) {
                _vm.closeModal(() => (_vm.contactStudio = false))
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c("SoliLocations", {
                        attrs: {
                          parentLocations: _vm.$page.props.auth.user.locations,
                          value: _vm.$page.props.auth.user.locations.find(
                            (e) => e.id == _vm.contactStudio.location.id
                          ),
                          iterator: "",
                          showAddress: "",
                          hideDetails: "",
                          expandable: "",
                          hideSearch: "",
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              4169877702
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }